import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingScreenComponent } from './loading-screen.component';

@NgModule({
  declarations: [LoadingScreenComponent],
  imports: [CommonModule],
  exports: [LoadingScreenComponent] // Ensure you export it if it's used in other modules
})
export class LoadingScreenModule {}